import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFolder,
  faFileExcel,
  faFilePowerpoint,
  faFileAlt,
  faFileWord,
  faFilePdf,
  faFile,
  faFileCsv,
  faTrash,
  faFileImage,
  faFileAudio,
  faFileVideo,
  faFileArchive,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons';

import { FileDto } from '../Document.interface';
import { FILE_TYPES } from '../Document.helpers';

type FileIconProps = Pick<FileDto, 'extension' | 'isFolder' | 'path'> & {
  className: string;
};

const getIconWithColor = (type: string): [IconDefinition, string] => {
  switch (type) {
    case 'folder':
      return [faFolder, ''];
    case 'xls':
    case 'xlsx':
    case 'xlsm':
      return [faFileExcel, '#217346'];
    case 'ppt':
    case 'pptx':
      return [faFilePowerpoint, '#d24726'];
    case 'text':
      return [faFileAlt, ''];
    case 'doc':
    case 'docx':
      return [faFileWord, '#2b579a'];
    case 'pdf':
      return [faFilePdf, '#F40F02'];
    case 'csv':
      return [faFileCsv, '#217346'];
    case 'trash':
      return [faTrash, ''];
    case 'image':
      return [faFileImage, ''];
    case 'audio':
      return [faFileAudio, ''];
    case 'video':
      return [faFileVideo, ''];
    case 'compressed':
      return [faFileArchive, ''];
    default:
      return [faFile, ''];
  }
};

const FileIcon: React.FC<FileIconProps> = ({
  isFolder,
  path,
  extension = '',
  className
}) => {
  let fileType = extension;
  if (isFolder) {
    fileType = path === 'Trash/' ? 'trash' : 'folder';
  } else if (FILE_TYPES.text.includes(extension)) {
    fileType = 'text';
  } else if (FILE_TYPES.audio.includes(extension)) {
    fileType = 'audio';
  } else if (FILE_TYPES.compressed.includes(extension)) {
    fileType = 'compressed';
  } else if (FILE_TYPES.images.includes(extension)) {
    fileType = 'image';
  } else if (FILE_TYPES.video.includes(extension)) {
    fileType = 'video';
  }
  const [icon, color] = getIconWithColor(fileType);
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className}
      size='lg'
      color={color}
      fixedWidth
    />
  );
};

export default FileIcon;
